// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "com.saakuru.app",
    name: "Saakuru All-in-One crypto App",
    homepage: "https://app.saakuru.com",
    image_id: "bb9120f9-9757-4aae-0378-3e4dc2f82100",
    app: {
        browser: "https://getmeta.one/",
        ios: "https://apps.apple.com/us/app/saakuru-all-in-one-crypto-app/id1627212812",
        android: "https://play.google.com/store/apps/details?id=ventures.aag.metaone",
        mac: "https://apps.apple.com/lt/app/saakuru-all-in-one-crypto-app/id1627212812",
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "metaone://",
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map